import React from 'react';
import { Button } from 'react-bootstrap';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  backgroundThemeState,
  contactButtonHoverState,
  darkModeState,
} from '../../../../atoms';
import {
  animatedNatureDarkIcon,
  animatedNatureIcon,
} from '../../../../data/photoUrls';
import {
  getContactButtonHoverColor,
  handleBackgroundChange,
} from '../../../../util';
import { Icon } from '../icons/NatureIcon';
import { animatedNatureBg } from '../theme/const';
import { SquareButtonProps } from './Squares';
import { useContactButtonHover } from '../../../../util/hooks';

export const AnimatedButton: React.FC<SquareButtonProps> = ({ className }) => {
  const darkMode = useRecoilValue(darkModeState);
  const setContactButtonHoverState = useSetRecoilState(contactButtonHoverState);
  const [background, setBackground] = useRecoilState(backgroundThemeState);
  const [lightIcon, setLightIcon] = React.useState(animatedNatureIcon);
  const [darkIcon, setDarkIcon] = React.useState(animatedNatureDarkIcon);
  useContactButtonHover(background);

  const handleHover = React.useCallback(() => {
    setLightIcon(animatedNatureDarkIcon);
    setDarkIcon(animatedNatureIcon);
  }, []);

  const handleClose = React.useCallback(() => {
    setLightIcon(animatedNatureIcon);
    setDarkIcon(animatedNatureDarkIcon);
  }, []);

  return (
    <div className={className.btnContainer}>
      <Button
        id="triangle"
        onMouseEnter={handleHover}
        onMouseLeave={handleClose}
        className={className.btn}
        onClick={() => {
          handleBackgroundChange(animatedNatureBg, setBackground);
          setContactButtonHoverState(getContactButtonHoverColor(background));
        }}
      >
        {!darkMode ? <Icon src={darkIcon} /> : <Icon src={lightIcon} />}
      </Button>
    </div>
  );
};
